'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _isArray = require('lodash/isArray');
var _get = require('lodash/get');
var format = require('date-fns/format');
var isBefore = require('date-fns/isBefore');
var isFuture = require('date-fns/isFuture');
var isValid = require('date-fns/isValid');
var parse = require('date-fns/parse');
var validate = require('./validate.js');
var abn = require('./abn.js');
require('yup');
require('core-js/es6/promise');
require('core-js/es6/set');
require('google-libphonenumber');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _isArray__default = /*#__PURE__*/_interopDefaultLegacy(_isArray);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var format__default = /*#__PURE__*/_interopDefaultLegacy(format);
var isBefore__default = /*#__PURE__*/_interopDefaultLegacy(isBefore);
var isFuture__default = /*#__PURE__*/_interopDefaultLegacy(isFuture);
var isValid__default = /*#__PURE__*/_interopDefaultLegacy(isValid);
var parse__default = /*#__PURE__*/_interopDefaultLegacy(parse);

var IS_VALID_BANK_ACCOUNT_NAME_REGEX = new RegExp(/^[A-Za-z0-9^_[\]',?;:=#/.*()&%!$ @+-]+$/);
var IS_VALID_NUMBER_REGEX = new RegExp(/^\d+$/);
var IS_VALID_BANK_ACCOUNT_NAME_REGEX_OPTIONAL = new RegExp(/^$|^[A-Za-z0-9^_[\]',?;:=#/.*()&%!$ @+-]+$/);
var IS_VALID_NUMBER_REGEX_OPTIONAL = new RegExp(/^$|^\d+$/);
var IS_VALID_MEDIBANK_PROVIDER_NUMBER_REGEX = new RegExp(/[A-Z]{1}[0-9]{5,6}[A-Z]{1,2}/);
var validEmailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"); // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isRequired = function isRequired(value) {
  return !value || value.trim && !value.trim() || _isArray__default["default"](value) && value.length === 0 ? 'This field is required' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isNumber = function isNumber(value) {
  return value && value.match(/[^0-9]/) ? 'This field must only contain numbers' : undefined;
};
var isEqualTo = // @ts-expect-error TS(7006): Parameter 'target' implicitly has an 'any' type.
function isEqualTo(target, message) {
  if (message === void 0) {
    message = "This field must be equal to " + target;
  }

  return (// @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
    function (value) {
      return target === value ? undefined : message;
    }
  );
};
var isSameValueAsField = // @ts-expect-error TS(7006): Parameter 'targetField' implicitly has an 'any' ty... Remove this comment to see the full error message
function isSameValueAsField(targetField, message) {
  if (message === void 0) {
    message = 'Fields must be the same';
  }

  return (// @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
    function (value, values) {
      return value === values[targetField] ? undefined : message;
    }
  );
};
var isLengthEqualTo = // @ts-expect-error TS(7006): Parameter 'length' implicitly has an 'any' type.
function isLengthEqualTo(length, message) {
  if (message === void 0) {
    message = "Field must contain " + length + " characters";
  }

  return (// @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
    function (value) {
      return !value || value.length === length ? undefined : message;
    }
  );
}; // @ts-expect-error TS(7006): Parameter 'length' implicitly has an 'any' type.

var isLengthGreaterThanOrEqualTo = function isLengthGreaterThanOrEqualTo(length) {
  return function (value) {
    return !value || value.split(' ').join('').length >= length ? undefined : "Must be greater than or equal to " + length + " characters";
  };
}; // @ts-expect-error TS(7006): Parameter 'length' implicitly has an 'any' type.

var isLengthLessThanOrEqualTo = function isLengthLessThanOrEqualTo(length) {
  return function (value) {
    return !value || value.split(' ').join('').length <= length ? undefined : "Must be less than or equal to " + length + " characters";
  };
}; // @ts-expect-error TS(7006): Parameter 'length' implicitly has an 'any' type.

var isLengthWithSpacesLessThanOrEqualTo = function isLengthWithSpacesLessThanOrEqualTo(length) {
  return function (value) {
    return !value || value.length <= length ? undefined : "Must be less than or equal to " + length + " characters";
  };
}; // @ts-expect-error TS(7006): Parameter 'length' implicitly has an 'any' type.

var isLengthWithSpacesGreaterThanOrEqualTo = function isLengthWithSpacesGreaterThanOrEqualTo(length) {
  return function (value) {
    return !value || value.length >= length ? undefined : "Must be greater than or equal to " + length + " characters";
  };
}; // @ts-expect-error TS(7006): Parameter 'length' implicitly has an 'any' type.

var isGreaterThanOrEqualTo = function isGreaterThanOrEqualTo(length) {
  return function (value) {
    return !value || parseFloat(value) >= length ? undefined : "Must be greater than or equal to " + length;
  };
}; // @ts-expect-error TS(7006): Parameter 'length' implicitly has an 'any' type.

var isGreaterThan = function isGreaterThan(length) {
  return function (value) {
    return !value || parseFloat(value) > length ? undefined : "Must be greater than " + length;
  };
}; // @ts-expect-error TS(7006): Parameter 'length' implicitly has an 'any' type.

var isLessThanOrEqualTo = function isLessThanOrEqualTo(length) {
  return function (value) {
    return !value || parseFloat(value) <= length ? undefined : "Must be less than or equal to " + length;
  };
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasUppercaseLetter = function hasUppercaseLetter(value) {
  return /[A-Z]/.test(value) ? undefined : 'Field must contain an uppercase letter';
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasNumber = function hasNumber(value) {
  return /[0-9]/.test(value) ? undefined : 'Field must contain a number';
}; // Adheres to the 'BECS EBCDIC' character set.
// @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isValidBankAccountName = function isValidBankAccountName(value) {
  return IS_VALID_BANK_ACCOUNT_NAME_REGEX.test(value) ? undefined : 'Bank account name must not contain any special characters';
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasSpecialChar = function hasSpecialChar(value) {
  return /[!@?#$%^&*)(+=._-]/.test(value) ? undefined : 'Field must contain a special character (e.g. !@#)';
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
// eslint-disable-line no-useless-escape

var isValidEmailAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee(value) {
    return _regeneratorRuntime__default["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = !value;

            if (_context.t0) {
              _context.next = 5;
              break;
            }

            _context.next = 4;
            return validate.isEmail(value);

          case 4:
            _context.t0 = _context.sent;

          case 5:
            if (!_context.t0) {
              _context.next = 9;
              break;
            }

            _context.t1 = undefined;
            _context.next = 10;
            break;

          case 9:
            _context.t1 = 'Please enter a valid email';

          case 10:
            return _context.abrupt("return", _context.t1);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function isValidEmailAsync(_x) {
    return _ref.apply(this, arguments);
  };
}(); // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isValidEmail = function isValidEmail(value) {
  return !value || validEmailRegex != null && validEmailRegex.test(value) ? undefined : 'Please enter a valid email';
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isValidMobile = function isValidMobile(value) {
  return !value || validate.isMobileNumber(value, 'AU') ? undefined : 'Please enter a valid mobile number';
};
var isValidLandline = function isValidLandline(value) {
  return !value || validate.isLandlineNumber(value, 'AU') ? undefined : 'Please enter a valid landline number';
};
var isValidDatePatterns = function isValidDatePatterns(_ref2) {
  var day = _ref2.day,
      month = _ref2.month,
      year = _ref2.year;
  return function (value) {
    if (!value) {
      return undefined;
    }

    if (day) {
      var valueArray = value.split('/');

      var dayValue = _get__default["default"](valueArray, "[" + day.index + "]", '').split(' ').join('');

      if (!new RegExp(day.regex).test(dayValue)) {
        return day.message;
      }
    }

    if (month) {
      var _valueArray = value.split('/');

      var monthValue = _get__default["default"](_valueArray, "[" + month.index + "]", '').split(' ').join('');

      if (!new RegExp(month.regex).test(monthValue)) {
        return month.message;
      }
    }

    if (year) {
      var _valueArray2 = value.split('/');

      var yearValue = _get__default["default"](_valueArray2, "[" + year.index + "]", '').split(' ').join('');

      if (!new RegExp(year.regex).test(yearValue)) {
        return year.message;
      }
    }

    return undefined;
  };
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isValidDate = function isValidDate(value) {
  return value && !isValid__default["default"](parse__default["default"](value, 'dd/MM/yyyy', new Date())) ? 'Date is invalid' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isValidUrlAsync = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator__default["default"]( /*#__PURE__*/_regeneratorRuntime__default["default"].mark(function _callee2(value) {
    return _regeneratorRuntime__default["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = !value;

            if (_context2.t0) {
              _context2.next = 5;
              break;
            }

            _context2.next = 4;
            return validate.isUrl(value);

          case 4:
            _context2.t0 = _context2.sent;

          case 5:
            if (!_context2.t0) {
              _context2.next = 9;
              break;
            }

            _context2.t1 = undefined;
            _context2.next = 10;
            break;

          case 9:
            _context2.t1 = 'Please enter a valid URL (starting with http:// or https://).';

          case 10:
            return _context2.abrupt("return", _context2.t1);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function isValidUrlAsync(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var isYearInRange = function isYearInRange(_ref4) {
  var index = _ref4.index,
      isShortYearFormat = _ref4.isShortYearFormat,
      lessThanCurrentYear = _ref4.lessThanCurrentYear;
  return function (value) {
    if (value === void 0) {
      value = '';
    }

    var year = value.split('/')[index];
    var currentYear = format__default["default"](new Date(), isShortYearFormat ? 'yy' : 'yyyy');

    if (!lessThanCurrentYear && (parseInt(year, 10) < parseInt(currentYear, 10) || parseInt(year, 10) > parseInt(currentYear, 10) + 15)) {
      if (parseInt(year, 10) < parseInt(currentYear, 10)) {
        return "Year must be a year equal or greater than " + parseInt(currentYear, 10);
      }

      if (parseInt(year, 10) > parseInt(currentYear, 10) + 15) {
        return "Year must be a year less than " + (parseInt(currentYear, 10) + 15);
      }

      return 'Please enter a valid year';
    }

    if (lessThanCurrentYear && parseInt(year, 10) > parseInt(currentYear, 10)) {
      return "Year must be a year equal or less than " + parseInt(currentYear, 10);
    }

    return undefined;
  };
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isValidDOB = function isValidDOB(value) {
  var invalidDate = isValidDate(value);
  if (invalidDate) return invalidDate;
  var year = value.split('/')[2];
  var currentYear = format__default["default"](new Date(), 'yyyy');

  if (parseInt(year, 10) > parseInt(currentYear, 10)) {
    return 'Year must be before current year.';
  }

  if (parseInt(year, 10) < 1900) {
    return 'Year must be greater than 1900';
  }

  return undefined;
}; // @ts-expect-error TS(7006): Parameter 'pattern' implicitly has an 'any' type.

var matchesRegex = function matchesRegex(pattern, message) {
  return function (value) {
    return !value || new RegExp(pattern).test(value) ? undefined : message;
  };
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isFutureDate = function isFutureDate(value) {
  var date = value && new Date(value.split('/')[2], value.split('/')[1] - 1, value.split('/')[0]);
  return isFuture__default["default"](date) ? 'Date must not be in the future.' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var isMoreThanThreeYears = function isMoreThanThreeYears(value) {
  var dateToValidate = new Date(value.split('/')[2], value.split('/')[1] - 1, value.split('/')[0]);
  var dateThreeYearsAgo = new Date(new Date().getFullYear() - 3, new Date().getMonth(), new Date().getDate() - 1);
  return isBefore__default["default"](dateToValidate, dateThreeYearsAgo) ? 'Date must not be more than 3 years ago.' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasInvalidCharacters = function hasInvalidCharacters(value) {
  return value && /[()]/.test(value) ? 'This field cannot contain ( or )' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasStrictInvalidCharacters = function hasStrictInvalidCharacters(value) {
  return value && /[^A-Za-z0-9-' ]/.test(value) ? 'This field cannot contain any special characters except for space, hyphen and apostrophe under certain conditions' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasDoubleSpaces = function hasDoubleSpaces(value) {
  return value && /\s\s+/g.test(value) ? 'There can be no double spaces in the supplied value' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasWhitespaceAtStartOrEnd = function hasWhitespaceAtStartOrEnd(value) {
  return value && /(^\s+)|(\s+$)/.test(value) ? 'There can be no spaces at the start or end of the supplied value' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasSpaceAfterHyphen = function hasSpaceAfterHyphen(value) {
  return value && /([-]\s)/.test(value) ? 'Name cannot have a space after a hyphen (-)' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasSpaceBeforeHyphen = function hasSpaceBeforeHyphen(value) {
  return value && /(\s[-])/.test(value) ? 'Name cannot have a space before a hyphen (-)' : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasSpaceAfterApostrophe = function hasSpaceAfterApostrophe(value) {
  return value && /([']\s)/.test(value) ? "Name cannot have a space after an apostrophe (')" : undefined;
}; // @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.

var hasSpaceBeforeApostrophe = function hasSpaceBeforeApostrophe(value) {
  return value && /(\s['])/.test(value) ? "Name cannot have a space before an apostrophe (')" : undefined;
};
var isValidAbn = function isValidAbn(value) {
  var isValid = abn.isValidAbn(value);

  if (isValid) return undefined;
  return 'Please enter a valid 11 digit ABN';
};

var combineValidators = // @ts-expect-error TS(7019): Rest parameter 'fns' implicitly has an 'any[]' typ... Remove this comment to see the full error message
function combineValidators() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return (// @ts-expect-error TS(7006): Parameter 'value' implicitly has an 'any' type.
    function (value) {
      var validator = fns.find(function (fn) {
        return fn(value);
      });

      if (validator) {
        return validator(value);
      }

      return undefined;
    }
  );
};

exports.IS_VALID_BANK_ACCOUNT_NAME_REGEX = IS_VALID_BANK_ACCOUNT_NAME_REGEX;
exports.IS_VALID_BANK_ACCOUNT_NAME_REGEX_OPTIONAL = IS_VALID_BANK_ACCOUNT_NAME_REGEX_OPTIONAL;
exports.IS_VALID_MEDIBANK_PROVIDER_NUMBER_REGEX = IS_VALID_MEDIBANK_PROVIDER_NUMBER_REGEX;
exports.IS_VALID_NUMBER_REGEX = IS_VALID_NUMBER_REGEX;
exports.IS_VALID_NUMBER_REGEX_OPTIONAL = IS_VALID_NUMBER_REGEX_OPTIONAL;
exports["default"] = combineValidators;
exports.hasDoubleSpaces = hasDoubleSpaces;
exports.hasInvalidCharacters = hasInvalidCharacters;
exports.hasNumber = hasNumber;
exports.hasSpaceAfterApostrophe = hasSpaceAfterApostrophe;
exports.hasSpaceAfterHyphen = hasSpaceAfterHyphen;
exports.hasSpaceBeforeApostrophe = hasSpaceBeforeApostrophe;
exports.hasSpaceBeforeHyphen = hasSpaceBeforeHyphen;
exports.hasSpecialChar = hasSpecialChar;
exports.hasStrictInvalidCharacters = hasStrictInvalidCharacters;
exports.hasUppercaseLetter = hasUppercaseLetter;
exports.hasWhitespaceAtStartOrEnd = hasWhitespaceAtStartOrEnd;
exports.isEqualTo = isEqualTo;
exports.isFutureDate = isFutureDate;
exports.isGreaterThan = isGreaterThan;
exports.isGreaterThanOrEqualTo = isGreaterThanOrEqualTo;
exports.isLengthEqualTo = isLengthEqualTo;
exports.isLengthGreaterThanOrEqualTo = isLengthGreaterThanOrEqualTo;
exports.isLengthLessThanOrEqualTo = isLengthLessThanOrEqualTo;
exports.isLengthWithSpacesGreaterThanOrEqualTo = isLengthWithSpacesGreaterThanOrEqualTo;
exports.isLengthWithSpacesLessThanOrEqualTo = isLengthWithSpacesLessThanOrEqualTo;
exports.isLessThanOrEqualTo = isLessThanOrEqualTo;
exports.isMoreThanThreeYears = isMoreThanThreeYears;
exports.isNumber = isNumber;
exports.isRequired = isRequired;
exports.isSameValueAsField = isSameValueAsField;
exports.isValidAbn = isValidAbn;
exports.isValidBankAccountName = isValidBankAccountName;
exports.isValidDOB = isValidDOB;
exports.isValidDate = isValidDate;
exports.isValidDatePatterns = isValidDatePatterns;
exports.isValidEmail = isValidEmail;
exports.isValidEmailAsync = isValidEmailAsync;
exports.isValidLandline = isValidLandline;
exports.isValidMobile = isValidMobile;
exports.isValidUrlAsync = isValidUrlAsync;
exports.isYearInRange = isYearInRange;
exports.matchesRegex = matchesRegex;
exports.validEmailRegex = validEmailRegex;
